export default __webpack_public_path__ + "static/media/ReadyForCheckout.7472a5f6.svg";